import Tooltip from 'react-toolbox/lib/tooltip';

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/common/material/Tooltip.js